export class WorkOrderWatcherModel {
    public userId: string;
    public sendInAppNotification: boolean;
    public sendEmailNotification: boolean;
}